class StickyBookingWidget {

    constructor(el) {
        this.el = el;
        // reveal on page load or after set time
        this.revealDelay = 8000; // 8 seconds as a fallback
        this.revealTimeout = setTimeout(() => {
            this.reveal();
        }, this.revealDelay);
        window.onload = () => {
            clearTimeout(this.revealTimeout);
            this.revealTimeout = null;
            this.reveal();
        };
    }

    reveal() {
        window.requestAnimationFrame(() => {
            // make element visible
            this.el.removeAttribute('hidden');
            window.requestAnimationFrame(() => {
                this.el.classList.add('show');
            });
        });
    }

}

new StickyBookingWidget(document.getElementById('sticky-booking-widget'));